<div class="" ref="reolve_request">
  <NavigationBackButton />
   <div class="custom-header rounded-lg mt-3">
          <p class="p-3 fw-bold text-white mb-0 text-x">Request Overview</p>
    </div>

    <div class="mt-4 rounded-lg border-0">
      <div class="p-4 rounded-lg glassy-bg">
        <div class="d-flex justify-content-between mb-3 text-xs">
          <span><span class="fw-bold">Request note:</span> {{ request_note }}</span>
          <span><span class="fw-bold">Date requested:</span> {{ date_requested }}</span>
        </div>  
        <hr/>
        <!-- Message Card -->
        <div class="card mb-3 border-0 shadow-sm hover-card gray-background shadow rounded-lg d-none">
          <div class="card-body px-3 py-2  shadow-sm">
            <p class="text-xs mt-3">{{ request_note }}</p>
            <div class="text-end text-xs text-muted">{{ date_requested }}</div>
          </div>
        </div>

        <div>
          <p class="text-x fw-bold mb-2">Documents requested:</p>
          <ul class="text-dark text-xs small mb-3 ps-3 ms-3">
            <li v-for="(doc, index) in fields" :key="index">{{ doc.label }}</li>
          </ul>
        </div>

        <!-- <p class="fw-bold mb-3 text-x my-4 mb-1">Response</p> -->
        <div class="ms-3 text-xs  p-3 rounded-lg glassy-table mt-4">
          <p class="fw-bold mb-2 text-x">Documents submitted</p>
          <div class="table-responsive text-xs">
            <!-- Table -->
            <table  id="resolve_request_table" class="table table-hover">
              <thead class="custom-header">
                <tr class="card-bg text-white">
                  <th class="text-uppercase text-xxs font-weight-bolder opacity-7 text-start ps-3">No</th>
                  <th class="text-uppercase text-xxs font-weight-bolder opacity-7 text-start ps-3">Document Name</th>
                  <th class="text-uppercase text-xxs font-weight-bolder opacity-7 text-start ps-3">Date Uploaded</th>
                  <th class="text-uppercase text-xxs font-weight-bolder opacity-7 text-start ps-3">Review Status</th>
                  <th class="text-uppercase text-xxs font-weight-bolder opacity-7 text-start ps-3">Action</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(doc, index) in request_response" :key="index">
                  <td>{{ index + 1 }}</td>
                  <td class="text-xxs text-start">{{ doc.name }}</td>
                  <td class="text-xxs text-start">{{ doc.date_created }}</td>
                  <td class="text-xxs text-start">
                    <span class="badge px-2 py-1" :class="{
                      'bg-success text-white': doc.review_status === 'Approved',
                      'bg-danger text-white': doc.review_status === 'Rejected',
                      'bg-secondary text-white': doc.review_status === 'Pending Review'
                    }">
                      {{ doc.review_status }}
                    </span>
                  </td>
                  <td class="text-xxs text-start">
                    <div class="d-flex flex-wrap gap-1">
                      <button type="button" class="btn btn-primary-dark btn-sm text-xxs shadow"
                        @click="open_document(doc)">
                        View
                      </button>
                      <button type="button" class="btn btn-primary-dark btn-sm text-xxs shadow"
                        :disabled="doc.review_status !== 'Pending Review'"
                        @click="approve_response(doc)">
                        Approve
                      </button>
                      <button type="button" class="btn btn-primary-dark btn-sm text-xxs shadow"
                        :disabled="doc.review_status !== 'Pending Review'"
                        @click="reject_response(doc)">
                        Reject
                      </button>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>


        <div class="ms-3 mt-3" v-if="request_response.length > 0">
          <p class="text-xs fw-bold mb-1 ">Notes</p>
          <textarea class="form-control bg-white text-xxs pt-2 resize-vertical rounded-lg" rows="4"></textarea>
        </div>
        <div class="d-flex justify-content-end mt-auto gap-2" v-if="request_response.length > 0">
          <button type="submit" class="btn btn-primary-dark btn-sm text-xxs shadow mt-3"
            :disabled="!can_resolve" @click="resolve_request">Resolve</button>
          <button type="submit" class="btn btn-primary-dark btn-sm text-xxs shadow mt-3 d-none">Respond</button>
        </div>
      </div>
    </div>
</div>

    


<div v-if="preview_modal" @click.self="preview_modal = false">
  <FilePreviewComponent :presigned_url="selected_file.presigned_url" @close="close_the_file_preview"
    :key="selected_file.presigned_url" />
</div>